import React from 'react';
import styles from './Loader.module.scss';

interface LoaderProps {
  size?: number;
  color?: string;
}

const Loader: React.FC<LoaderProps> = ({ size = 40, color = '#6E59FE' }) => {
  return (
    <div className={styles.loaderContainer}>
      <div 
        className={styles.loader}
        style={{
          width: size,
          height: size,
          borderColor: color,
          borderTopColor: 'transparent'
        }}
      />
    </div>
  );
};

export default Loader; 